import { render, staticRenderFns } from "./TiptapRadioList.vue?vue&type=template&id=108fb919"
import script from "./TiptapRadioList.vue?vue&type=script&lang=js"
export * from "./TiptapRadioList.vue?vue&type=script&lang=js"
import style0 from "./TiptapRadioList.vue?vue&type=style&index=0&id=108fb919&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports